import { Link, Icon, Alert, AlertTypography, Stack } from '@ace-clublabs/shared-component-library';
import { useState, useContext, JSX } from 'react';
import { MembershipAppStateContext } from '../MembershipAppState/MembershipAppState';
import { FlowType } from '@ace-clublabs/common-membership-api-types';
import { GreenBoxModal } from './GreenBoxModal';

export interface GreenBoxMessageProps {
  flowType: FlowType;
  shortBoxMessage?: string;
  modalTitle?: string;
  modalBody?: string;
}

export const GreenBoxMessage: (props: GreenBoxMessageProps) => JSX.Element = ({
  flowType,
  shortBoxMessage,
  modalTitle,
  modalBody,
}) => {
  const { sessionData } = useContext(MembershipAppStateContext);
  const [showGreenBoxModal, setShowGreenBoxModal] = useState(false);
  const isMajorRocketFlow = flowType === FlowType.MAJOR_ROCKET;

  if (!shortBoxMessage) return <></>;

  return (
    <Stack className="green-box-container" key="bene-coupon" width={'100%'} marginBottom={'1.5rem'}>
      <Alert
        severity="success"
        displayCloseButton={false}
        sx={{ backgroundColor: '#F3E9FE', width: '100% !important', alignSelf: 'center', maxWidth: '29.75rem' }}
        icon={<Icon iconName="tags-duotone" sx={{ color: '#7527B9' }} className="benefit-coupon-icon"></Icon>}
      >
        <AlertTypography className="green-box-message" sx={{ fontSize: '0.875rem !important' }}>
          {shortBoxMessage}{' '}
          {modalTitle && modalBody && !isMajorRocketFlow && (
            <Link
              onClick={() => setShowGreenBoxModal(true)}
              sx={{ color: '#0156A3', fontSize: '0.875rem !important' }}
              className="learn-more-link"
            >
              Learn more
            </Link>
          )}
        </AlertTypography>
      </Alert>
      <GreenBoxModal
        showGreenBoxModal={showGreenBoxModal}
        modalTitle={sessionData.membershipContent?.greenBoxMessage?.modalTitle ?? ''}
        modalContent={sessionData.membershipContent?.greenBoxMessage?.modalBody ?? ''}
        closeModal={() => {
          setShowGreenBoxModal(false);
        }}
      />
    </Stack>
  );
};
